import { Component, Input } from '@angular/core';
import { ETAType } from '../eta-type.model';

@Component({
  selector: 'app-delivery-eta-type-icon',
  templateUrl: './delivery-eta-type-icon.component.html',
  styleUrls: ['./delivery-eta-type-icon.component.scss']
})
export class DeliveryEtaTypeIconComponent {

  @Input() public etaType: ETAType;

  public ETA_TYPE = ETAType
}
